import { IAlertsFilterState } from '../redux/slices/alertSlice'
import { FetchAlertsParams } from '../services/alertServices'

/**
 * Converts Redux alert filter state into API query params.
 * Shared between AlertsList (list query + export) and Intransit (unread count).
 */
export const buildAlertFilterParams = (
    filters: IAlertsFilterState,
    userTimeZone?: string,
): FetchAlertsParams => {
    let sortAttr = 'timestamp'
    if (filters.sortParams.orderAttribute === 'severity') sortAttr = 'severity'
    else if (filters.sortParams.orderAttribute === 'time')
        sortAttr = 'timestamp'
    else if (filters.sortParams.orderAttribute)
        sortAttr = filters.sortParams.orderAttribute

    const params: FetchAlertsParams = {
        searchText: filters.searchValue?.trim() || '',
        searchAttributeName: filters.searchValue
            ? filters.selectedColumn?.attributeName ?? ''
            : '',
        searchAttributeType: filters.searchValue
            ? filters.selectedColumn?.attributeType ?? ''
            : '',
        alertStartDate: filters.dateRange?.[0] || '',
        alertEndDate: filters.dateRange?.[1] || '',
        alertSortAttribute: sortAttr,
        alertSortOrder: filters.sortParams.orderBy,
        localTimeZone:
            userTimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone,
        filters: [],
        entitySearch: true,
    }

    if (filters.severityFilter.length > 0) {
        params.alertSeverity = [...filters.severityFilter]
    }
    if (filters.alertTypeFilter.length > 0) {
        params.alertType = [...filters.alertTypeFilter]
    }
    if (filters.readStatusFilter.length > 0) {
        params.alertStatus = filters.readStatusFilter.map((e) =>
            Number.parseInt(e),
        )
    }
    if (filters.productFilter?.length > 0) {
        const productIds = filters.productFilter.map((p: any) =>
            typeof p === 'object' ? p.entityId : p,
        )
        params.filters?.push({
            attributeId: 'product',
            values: productIds,
        })
    }
    if (filters.columnFilters?.length > 0) {
        params.filters?.push(
            ...filters.columnFilters
                .filter((filter) => filter.id && filter.value)
                .map((filter) => ({
                    attributeId: filter.id,
                    values: [filter.value],
                })),
        )
    }

    return params
}
